import React, { useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import OTPInput from "react-otp-input";
import { toast } from "react-toastify";
import { api } from "../../api/api";
import { bank_details_api, Reotp_url, upi_api } from "../../api/urls";
import { ChevronLeft } from "lucide-react";
import { encrypt } from "../../utils/encryption";

const ReturnCOD = ({
  setClose,
  token,
  refundMethod,
  orderID,
  orderData,
  setStep,
}) => {
  const [verifyOTP, setVerifyOTP] = useState("");
  const [next, setNext] = useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      bank_account_number: "",
      confirm_account_number: "",
      bank_ifsc_number: "",
    },
  });
  const {
    control: control2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    watch: watch2,
  } = useForm({
    defaultValues: {
      upi_details: "",
    },
  });
  const accountNumber = watch("bank_account_number");
  const upi_number = watch2("upi_details");
  const handleResend = async () => {
    try {
      await api.post(Reotp_url, {});
      setVerifyOTP(Array(6).fill(""));
      // setTimer(30);
      // setResendDisabled(true);
    } catch (err) {
      console.error("Error Resending OTP:", err);
      toast.error(err.response?.data?.message || "Failed to resend OTP.");
    }
  };
  const onSubmit = async (data) => {
    const bankPayload = {
      // ...data,
      cart_id: orderID,
      order_id: orderData.order_id,
      recipient_otp: verifyOTP,
      bank_account_number: encrypt(data?.bank_account_number),
      bank_ifsc_number: encrypt(data?.bank_ifsc_number),
    };
    try {
      await api.post(bank_details_api, bankPayload, {
        headers: {
          Token: token,
        },
      });
      setStep(3);
    } catch (error) {
      toast.error(error?.response?.data || "Something went wrong");
    }
  };
  const onSubmit2 = async (data) => {
    const upiPayload = {
      // ...data,
      cart_id: orderID,
      order_id: orderData.order_id,
      recipient_otp: verifyOTP,
      upi_details: encrypt(data?.upi_details),
    };
    try {
      await api.post(upi_api, upiPayload, {
        headers: {
          Token: token,
        },
      });
      setStep(3);
    } catch (error) {
      toast.error(error?.response?.data?.data || "Something went wrong");
    }
  };

  return (
    <div>
      <div className="back-button" onClick={() => setClose(false)}>
        <ChevronLeft size={20} />
        <span>Go to back</span>
      </div>
      {!next && (
        <div>
          <h2>Verification Required</h2>
          <div
            style={{
              minHeight: "180px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div>
              <OTPInput
                value={verifyOTP}
                onChange={setVerifyOTP}
                inputType="tel"
                shouldAutoFocus
                renderSeparator={<span></span>}
                renderInput={(props) => <input {...props} />}
                numInputs={6}
                inputStyle={{
                  width: "3rem",
                  height: "3rem",
                  margin: "0 0.5rem",
                  fontSize: "1.5rem",
                  borderRadius: 4,
                  border: "1px solid #ccc",
                }}
              />
              <p
                onClick={handleResend}
                style={{ textAlign: "end", marginTop: "10px" }}
              >
                Resend OTP
              </p>
            </div>
          </div>
          <Box sx={{ mt: 3, textAlign: "end" }}>
            <Button
              variant="contained"
              onClick={() => setNext(true)}
              disabled={verifyOTP.length !== 6}
              sx={{
                textTransform: "none",
                backgroundColor: "#000",
                color: "#fff",
                px: 4,
                "&:hover": { backgroundColor: "#222" },
              }}
            >
              Continue
            </Button>
          </Box>
        </div>
      )}
      {next && (
        <>
          {refundMethod === "Add Bank Account" && (
            <div>
              <h2>Add Bank Account</h2>

              <form onSubmit={handleSubmit(onSubmit)}>
                <Box sx={{ flex: 1, minWidth: 0, maxWidth: "400px" }}>
                  <div>
                    <Typography sx={{ mt: 2 }}>Account Number</Typography>
                    <Controller
                      name="bank_account_number"
                      control={control}
                      rules={{ required: "Account Number is required" }}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          placeholder="Account Number"
                          fullWidth
                          margin="normal"
                          sx={{ mt: 0 }}
                          error={!!errors.bank_account_number}
                          helperText={errors.bank_account_number?.message}
                        />
                      )}
                    />
                  </div>

                  <Typography sx={{ mt: 2 }}>Confirm Account Number</Typography>
                  <Controller
                    name="confirm_account_number"
                    control={control}
                    rules={{
                      required: "Please confirm your account number",
                      validate: (value) =>
                        value === accountNumber ||
                        "Account numbers do not match",
                    }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        placeholder="Confirm Account Number"
                        fullWidth
                        margin="normal"
                        sx={{ mt: 0 }}
                        error={!!errors.confirm_account_number}
                        helperText={errors.confirm_account_number?.message}
                      />
                    )}
                  />

                  <Typography sx={{ mt: 2 }}>Bank IFSC</Typography>
                  <Controller
                    name="bank_ifsc_number"
                    control={control}
                    rules={{ required: "IFSC is required" }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        placeholder="Bank IFSC"
                        fullWidth
                        margin="normal"
                        sx={{ mt: 0 }}
                        error={!!errors.bank_ifsc_number}
                        helperText={errors.bank_ifsc_number?.message}
                      />
                    )}
                  />
                </Box>

                <Box sx={{ mt: 3, textAlign: "end" }}>
                  <Button
                    variant="contained"
                    type="submit"
                    sx={{
                      textTransform: "none",
                      backgroundColor: "#000",
                      color: "#fff",
                      px: 4,
                      "&:hover": { backgroundColor: "#222" },
                    }}
                  >
                    Continue
                  </Button>
                </Box>
              </form>
            </div>
          )}
          {refundMethod === "UPI ID" && (
            <div>
              <h2>Add UPI ID</h2>
              <p style={{ color: "gray", marginTop: "10px" }}>
                The UPI ID is in the format of name/phone number@bankname
              </p>
              <form
                onSubmit={handleSubmit2(onSubmit2)}
                style={{ marginTop: "15px" }}
              >
                <Controller
                  name="upi_details"
                  control={control2}
                  rules={{ required: "UPI ID is required" }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="UPI ID"
                      fullWidth
                      margin="normal"
                      sx={{ mt: 0, maxWidth: "400px" }}
                      error={!!errors2.upi_details}
                      helperText={errors2.upi_details?.message}
                    />
                  )}
                />
                <Box sx={{ mt: 3, textAlign: "end" }}>
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={!upi_number}
                    sx={{
                      textTransform: "none",
                      backgroundColor: "#000",
                      color: "#fff",
                      px: 4,
                      "&:hover": { backgroundColor: "#222" },
                    }}
                  >
                    Continue
                  </Button>
                </Box>
              </form>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ReturnCOD;
